var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPlay = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M4 14.129V9.87c0-3.578 0-5.367.99-6.212a2.9 2.9 0 0 1 1.073-.58c1.26-.37 2.817.578 5.93 2.474l3.493 2.129c2.803 1.707 4.205 2.561 4.455 3.75.079.374.079.761 0 1.137-.25 1.188-1.652 2.041-4.455 3.75l-3.494 2.128c-3.112 1.896-4.668 2.845-5.929 2.474a2.9 2.9 0 0 1-1.072-.58C4 19.496 4 17.707 4 14.129"
})));
export default SvgPlay;